import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSystemMessage, selectSystemMessageEnabled } from '~/components/brand/ducks/selectors';
import { showNotification } from '~/components/notifications/ducks/notifications';

const SystemMessage = () => {
	const systemMessageEnabled = useSelector(selectSystemMessageEnabled);
	const systemMessage = useSelector(selectSystemMessage);
	const dispatch = useDispatch();

	useEffect(() => {
		if (systemMessageEnabled) {
			dispatch(
				showNotification({
					messageKey: systemMessage,
					color: 'neutral',
					autoHide: false
				})
			);
		}
	}, [dispatch, systemMessage, systemMessageEnabled]);

	return null;
};

export default SystemMessage;
